module.exports = __webpack_public_path__ + "static/media/15.06f6640b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyes/15.png
// module id = 1225
// module chunks = 0